import { render, staticRenderFns } from "./CompetitionQuery.vue?vue&type=template&id=6ac1f7a7&scoped=true"
import script from "./CompetitionQuery.vue?vue&type=script&lang=js"
export * from "./CompetitionQuery.vue?vue&type=script&lang=js"
import style0 from "./CompetitionQuery.vue?vue&type=style&index=0&id=6ac1f7a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac1f7a7",
  null
  
)

export default component.exports